const { ADOBE_FEATURE_NAME, ADOBE_CONST_VALUES, APP_CODE_MAPPING } = require('./constants');

module.exports = (flex = window.flex) => {
    const getAdobe = () => {
        const { _satellite: adobe } = window;
        const { location } = window;

        if (!flex.isFeatureToggleEnabled(ADOBE_FEATURE_NAME)) {
            return null;
        }

        if (!adobe) {
            console.warn(`${ADOBE_FEATURE_NAME} feature enabled but Adobe Analytics is not found`);
            return null;
        }

        return adobe;
    };

    const getDefaultPageData = () => {
        const { location } = window;
        const { appContext } = flex.getStore();
        const { app, session } = appContext;

        const pageName = location.pathname.split('/').pop();
        const siteCode = APP_CODE_MAPPING[app.code] || app.code;
        const environment = appContext.environment;
        const platform = ADOBE_CONST_VALUES.PLATFORM_NAME;
        const application = app.summary;
        const applicationRevisionId = app.version;
        const language = ADOBE_CONST_VALUES.LANGUAGE;
        const loginName = (session && session.user && session.user.username) || null;
        const sessionId = (session && session.token) || null;
        const loadTime = new Date().toString();
        const pageType = ADOBE_CONST_VALUES.PAGE_TYPE;

        return {
            pageName,
            siteCode,
            environment,
            platform,
            application,
            applicationRevisionId,
            language,
            loginName,
            sessionId,
            loadTime,
            pageType
        };
    };

    const setWebData = (data) => {
        const defaultPageData = getDefaultPageData();

        const webData = { ...defaultPageData, ...data };

        window.webData = webData;
    };

    const track = (eventName, data) => {
        const adobe = getAdobe();

        if (!adobe) {
            return;
        }

        setWebData(data);

        adobe.track(eventName);
    };

    const sendPageView = (data) => {
        track('pageView', data);
    };

    const sendCustomEvent = (data) => {
        track('customEvent', data);
    };

    const sendAppEvent = (data) => {
        const { appEventData = [] } = window;

        const defaultPageData = getDefaultPageData();

        const eventData = { ...defaultPageData, ...data };

        appEventData.push(eventData);
    };

    return { sendPageView, sendCustomEvent, sendAppEvent, getDefaultPageData, setWebData };
};
